// src/features/auth/authSlice.ts
import { createSlice } from "@reduxjs/toolkit";
import { Paciente, User } from "../api/pacientesAuthMe.api";

interface AuthState {
  user: unknown | null;
  accessToken: string | null;
  refreshToken: string | null;
  userRole: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  // Nuevos campos para paciente
  pacienteData: Paciente | null;
  userData: User | null;
  userId: number | null;
  pacienteId: number | null;
}

const initialState: AuthState = {
  user: null,
  accessToken: null,
  refreshToken: null,
  userRole: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
  // Inicializar nuevos campos
  pacienteData: null,
  userData: null,
  userId: null,
  pacienteId: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearAuthState(state) {
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.userRole = null;
      state.isAuthenticated = false;
      state.error = null;
      state.pacienteData = null;
      state.userData = null;
      state.userId = null;
      state.pacienteId = null;
    },
    updateTokens(state, action) {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.user = action.payload.user;
      state.userRole = action.payload.user?.role || null;
      state.isAuthenticated = true;
    },
    logout(state) {
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.userRole = null;
      state.isAuthenticated = false;
      state.pacienteData = null;
      state.userData = null;
      state.userId = null;
      state.pacienteId = null;
    },
    // Nueva acción para establecer datos del paciente
    setPacienteData(state, action) {
      state.pacienteData = action.payload.paciente;
      state.userData = action.payload.user;
      state.userId = action.payload.user.userId;
      state.pacienteId = action.payload.paciente.pacienteId;
      state.isLoading = false;
      state.error = null;
    },
    // Acción para cargar datos
    setPacienteLoading(state) {
      state.isLoading = true;
    },
    // Acción para errores
    setPacienteError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    }
  },
});

export const { 
  clearAuthState, 
  updateTokens, 
  logout, 
  setPacienteData,
  setPacienteLoading,
  setPacienteError 
} = authSlice.actions;
export default authSlice.reducer;
